<template>
  <settings-indexes-xml-feed v-if="activeForm === KNOWLEDGE_BASES.XML_FEED"
                             :url="xmlFeedSettings.url"
                             :item="xmlFeedSettings.item"
                             :item-name="xmlFeedSettings.itemName"
                             :item-id="xmlFeedSettings.itemId"
                             :vectorization-skip-tags="xmlFeedSettings.vectorizationSkipTags"
                             @update:url="updateXMLFeed( { url: $event })"
                             @update:item="updateXMLFeed( { item: $event })"
                             @update:item-name="updateXMLFeed( { itemName: $event })"
                             @update:item-id="updateXMLFeed( { itemId: $event })"
                             @update:vectorization-skip-tags="updateXMLFeed( { vectorizationSkipTags: $event })"
  />

  <settings-indexes-web-page v-else-if="activeForm === KNOWLEDGE_BASES.WEB_PAGE"
                             :url="webPageSettings.url"
                             :prompt="webPageSettings.prompt"
                             :format="webPageSettings.format"
                             :headerKey="webPageSettings.headerKey"
                             :headerValue="webPageSettings.headerValue"
                             @onAddHeaderChecked="updateWebPageSettings({ headerKey: $event.headerKey, headerValue: $event.headerValue })"
                             @update:url="updateWebPageSettings({ url: $event })"
                             @update:prompt="updateWebPageSettings({ prompt: $event })"
                             @update:format="updateWebPageSettings({ format: $event })"
                             @update:headerKey="updateWebPageSettings({ headerKey: $event })"
                             @update:headerValue="updateWebPageSettings({ headerValue: $event })"
  />

  <settings-indexes-file v-else
                         :file="fileSettings.file"
                         :url="fileSettings.url"
                         @update:file="updateFileSettings({file: $event})"
                         @update:url="updateFileSettings({url: $event})"
                         @reset:fileSettings="resetFileSettings"
  />
</template>

<script>
import SettingsIndexesFile from '@/components/settings/indexes/SettingsIndexesFile.vue'
import SettingsIndexesXmlFeed from '@/components/settings/indexes/SettingsIndexesXmlFeed.vue'
import SettingsIndexesWebPage from '@/components/settings/indexes/SettingsIndexesWebPage.vue'
import { KNOWLEDGE_BASES } from '@/utils/knowledgeBase.constants'

export default {
  name: 'SettingsIndexesForms',
  components: { SettingsIndexesXmlFeed, SettingsIndexesFile, SettingsIndexesWebPage },
  props: {
    fileSettings: Object,
    xmlFeedSettings: Object,
    webPageSettings: Object,
    activeForm: String
  },
  data() {
    return {
      KNOWLEDGE_BASES
    }
  },
  watch: {
    activeForm: {
      immediate: false,
      handler(form) {
        if (form === KNOWLEDGE_BASES.FILE) {
          this.resetXMLFeedSettings()
          this.resetWebPageSettings()
        } else if (form === KNOWLEDGE_BASES.WEB_PAGE) {
          this.resetXMLFeedSettings()
          this.resetFileSettings()
        } else {
          this.resetFileSettings()
          this.resetWebPageSettings()
        }

        this.$emit('update:activeForm', form)
      }
    }
  },
  methods: {
    updateWebPageSettings(update) {
      this.$emit('update:webPageSettings', { ...this.webPageSettings, ...update })
    },
    updateXMLFeed(update) {
      this.$emit('update:xmlFeedSettings', { ...this.xmlFeedSettings, ...update })
    },
    updateFileSettings(update) {
      this.$emit('update:fileSettings', { ...this.fileSettings, ...update })
    },
    resetWebPageSettings() {
      this.$emit('update:webPageSettings', { url: '', prompt: '', headerKey: null, headerValue: null })
    },
    resetXMLFeedSettings() {
      this.$emit('update:xmlFeedSettings', { url: '', item: '', itemName: '', itemId: '', vectorizationSkipTags: [] })
    },
    resetFileSettings() {
      this.$emit('update:fileSettings', { file: null, url: '' })
    }
  }
}
</script>
